import { css } from "@emotion/css";
import { theme } from "assets/theme";
import { Text } from "components/common";
import {
  BackwardIcon,
  ForwardIcon,
  PauseIcon,
  PlayIcon,
} from "components/icons";
import React from "react";
import { secondsToMinutes } from "utils/helpers";
import { AudioProgressBar } from "./audio-progress-bar";

type Props = {
  isPlaying?: boolean;
  currentTime?: number;
  duration?: number;
  play: () => void;
  pause: () => void;
  seekToTime: (time: number) => void;
};
export const AudioPlayerView: React.FC<Props> = ({
  isPlaying,
  duration,
  currentTime,
  play,
  pause,
  seekToTime,
}) => {
  const progress = duration ? (currentTime || 0) / duration : 0;
  const remaining = duration ? duration - (currentTime || 0) : 0;
  return (
    <div
      className={css`
        border-radius: 16px;
        border: 1px solid #2e2d33;
        padding: 23px 28px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background-color: ${theme.colors.primary["primary/01"]};
        @media (max-width: 700px) {
          position: fixed;
          bottom: 24px;
          left: 24px;
          width: calc(100% - 48px);
          padding-left: 12px;
          padding-right: 12px;
        }
        @media (max-height: 700px) {
          padding-top: 8px;
          padding-bottom: 8px;
        }
      `}
    >
      <div
        className={css`
          border-radius: 39px;
          width: 48px;
          height: 48px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          background-color: #6a53fe;
          cursor: pointer;
        `}
        onClick={() => (isPlaying ? pause() : play())}
      >
        {isPlaying ? (
          <PauseIcon
            fill="#1514193"
            style={{ width: "24px", height: "24px" }}
          />
        ) : (
          <PlayIcon fill="#1514193" style={{ width: "24px", height: "24px" }} />
        )}
      </div>
      <div
        className={css`
          width: calc(100% - 96px);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        `}
      >
        {/* <progress
          value={progress}
          className={css`
            width: 100%;
          `}
        /> */}
        <AudioProgressBar progress={progress} />
        <div
          className={css`
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-top: 5px;
          `}
        >
          <Text.Body3XS style={{ color: "#403F48", fontSize: "10px" }}>
            {secondsToMinutes(currentTime || 0)}
          </Text.Body3XS>
          <Text.Body3XS style={{ color: "#403F48", fontSize: "10px" }}>
            {secondsToMinutes(remaining)}
          </Text.Body3XS>
        </div>
      </div>
      <div
        className={css`
          border-radius: 39px;
          width: fit-content;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
        `}
      >
        <ForwardIcon
          fill="#BEBEBE"
          style={{
            width: "23px",
            height: "23px",
            cursor: "pointer",
            marginBottom: "10px",
          }}
          onClick={() => seekToTime((currentTime || 0) + 10)}
        />
        <BackwardIcon
          fill="#BEBEBE"
          style={{ width: "23px", height: "23px", cursor: "pointer" }}
          onClick={() => seekToTime((currentTime || 0) - 10)}
        />
      </div>
    </div>
  );
};
